import { type ActorEvent, type Arrangement, CUSTOM_VIEW_LAYOUT, type CustomViewLayout, type RecordLikeProtocol } from '@lighthouse/core'
import type { FlowLayoutNode } from '@lighthouse/shared'
import React, { forwardRef, memo } from 'react'

import { VerticalScrollView } from './VerticalScrollView'
import { WaterfallScrollView } from './WaterfallScrollView'

interface Props {
    anchorId?: string
    node: FlowLayoutNode
    itemWidth: number
    title: string
    cols: number
    gap: number
    layout: CustomViewLayout
    arrangement: Arrangement
    readonly?: boolean
    scale?: number
    enableDrag?: boolean
    sortId?: string
    onRecordClick?: (id: string, actorEvent: ActorEvent, record?: RecordLikeProtocol) => Promise<void>
    onUpdateRecord?: (recordId: string, content: RecordLikeProtocol['content']) => Promise<RecordLikeProtocol>
}

export const VerticalView = memo(
    forwardRef<HTMLDivElement, Props>((props, ref) => {
        const {
            anchorId,
            node,
            itemWidth,
            title,
            cols,
            gap,
            layout,
            arrangement,
            readonly,
            scale = 1,
            enableDrag,
            sortId,
            onRecordClick,
            onUpdateRecord
        } = props

        if (layout === CUSTOM_VIEW_LAYOUT.waterfall) {
            return (
                <WaterfallScrollView
                    ref={ref}
                    anchorId={anchorId}
                    node={node}
                    title={title}
                    readonly={readonly}
                    gap={gap}
                    cols={cols}
                    layout={layout}
                    arrangement={arrangement}
                    itemWidth={itemWidth}
                    onRecordClick={onRecordClick}
                />
            )
        }

        return (
            <VerticalScrollView
                ref={ref}
                anchorId={anchorId}
                node={node}
                title={title}
                readonly={readonly}
                gap={gap}
                cols={cols}
                layout={layout}
                arrangement={arrangement}
                itemWidth={itemWidth}
                enableDrag={enableDrag}
                sortId={sortId}
                onRecordClick={onRecordClick}
                onUpdateRecord={onUpdateRecord}
            />
        )
    })
)
